import Timeline from './Timeline';
export default Timeline;


//////////////////
// WEBPACK FOOTER
// /Users/qixian.cs/Documents/GitHub/ant-design-pro-site/scaffold/node_modules/antd/es/timeline/index.js
// module id = 856
// module chunks = 0